

let FormatMoneyComponent = ({amount}) => {
    return <>
        <span>{amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  : 0}</span>
    </>
}

export default FormatMoneyComponent;